export const CS_F_VERSION: string = "1.3.5";


// WEBPACK FOOTER //
// ./src/app/constants/version.ts